import { FC } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';

type Props = {
  open: boolean;
  title?: string | JSX.Element;
  isLoading: boolean;
  onClose: () => any;
  onSubmit: () => any;
};

export const SaveChangesDialog: FC<Props> = ({
  open,
  title = "Are you sure you want to save changes ?",
  isLoading,
  onSubmit,
  onClose
}) => {
  if (!open) return null;
  return (
    <div>
      <Dialog
        open={open}
        onClose={() => onClose()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogActions>
          {!isLoading ? (
            <Button onClick={() => onClose()}>No</Button>
          ) : (
            <></>
          )}
          <Button onClick={() => onSubmit()} autoFocus disabled={isLoading}>
            {!isLoading ? 'Yes' : 'Loading...'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
